import moment from "moment";
import React, { useState } from "react";
import Table2 from "../../../../templates/components/Table2";
import ModalBox from "../../../../templates/components/ModalBox";
import InvoicePreview from "../../invoices/invoice-preview/InvoicePreview";
import InvoiceButtonGroup from "../../../../../services/commonservice/invoice-button-group.utility";
import { Icon, IconGroup } from "semantic-ui-react";
import AddInvoice from "../../invoices/add-invoice/AddInvoice";
import AppointmentButtonGroup from "../../../../../services/commonservice/appointment-button-group.utility";

const AppointmentTable = (props) => {
  const [appointments, setAppointments] = useState(props.appointments || []);
  const [selectedAppointment, setSelectedAppointment] = useState()
  const [viewInvoice, setViewInvoice] = useState(false)
  const [confirmCreateInvoice, setConfirmCreateInvoice] = useState(false)
  const [checkOutInvoice, setCheckOutInvoice] = useState(null)
  const tableColumns = [
    {
      id: "date",
      Header: "Date",
      accessor: (row) => {
        return (
          <span>
            {row.providerRequested === 1 && <i className='ui icon' title='Provider Requested'><b>R</b></i>}
            {row.fromDate ? moment(row.fromDate).format("MM-DD-YYYY") : ""}
          </span>
        )
      },
      getCellExportValue: (row) => {
        let dateText = row.original.fromDate ? moment(row.original.fromDate).format("MM-DD-YYYY") : "";
        if (row.original.providerRequested === 1) {
          dateText = "R " + dateText;
        }
        return dateText;
      }
    },
    {
      id: "time",
      Header: "Time",
      accessor: (row) => {
        return row.fromDate ? `${moment(row.fromDate).format('h:mm')}-${moment(row.toDate).format('h:mm A')}` : ""
      }
    },
    {
      id: "doctorId",
      Header: "Provider",
      accessor: (row) => {
        return row.drFirstName ? `${row.drFirstName} ${row.drLastName}` : ""
      }
    },
    {
      id: "appointmentStatusCode",
      Header: "Status",
      accessor: (cell) => cell.appointmentStatusCode || "",
    }, {
      id: "practiceServiceType",
      Header: "Service",
      accessor: (cell) => cell.practiceServiceType || "",
    },
    {
      id: "practiceLocation",
      Header: "Practice Location",
      accessor: (cell) => cell.practiceLocation || "",
    },
    {
      id: "action",
      Header: "Action",
      textAlign: 'center',
      excludeFromExport: true, //to exclude from export
      disableSortBy: true,
      accessor: (cell, i) => {
        const invoiceButtons = !cell.parentGroupId && (
          <>
            <button
              className="p-0 ps-1 btn btn-primary"
              title="Create Invoice"
              onClick={() => handleCreateInvoice(cell)}
            >
              <IconGroup style={{ 'margin': '0 .15rem 0 0' }}>
                <Icon name='file outline' />
                <Icon corner='bottom right' name='dollar' color="green" />
              </IconGroup>
            </button>
          </>
        );

        const handleCreateInvoice = (appointment) => {
          setSelectedAppointment(appointment);
          setConfirmCreateInvoice(true);
        };
        return (
          !cell.parentGroupId && (
            <span className="row justify-content-end">
              <div className="col-auto btn-group">
                {cell.invoiceId ?
                  <InvoiceButtonGroup
                    buttonClass={'p-0 ps-1'}
                    initialData={cell}
                    invoiceId={cell.invoiceId}
                    //extraButton={extraButtons}
                    refresh={() => { props.refresh() }}
                  ></InvoiceButtonGroup>
                  : invoiceButtons
                }
              </div>
              <div className="col-auto btn-group">
                <AppointmentButtonGroup
                  buttonClass={'p-0 ps-1'}
                  initialData={cell}
                  //extraButton={extraButtons}
                  refresh={() => { props.refresh() }}
                ></AppointmentButtonGroup>
              </div>
            </span>
          ))
      }
    }
  ];

  const checkOut = () => {
    let newEvent = { ...selectedAppointment };
    newEvent.childServices = [];
    const childAppointments = appointments.filter((appointment) => appointment.parentGroupId === selectedAppointment.id).map((appt) => ({
      practiceServiceTypeId: appt.practiceServiceTypeId,
      doctorId: appt.doctorId
    }));
    if (childAppointments.length > 0) {
      newEvent.childServices = childAppointments
    }
    setCheckOutInvoice(newEvent)
  }
  return (
    <div title="Appointments">
      <Table2
        data={appointments}
        columns={tableColumns}
        loading={props?.loading}
        export
        title={`Appointments${props?.patientName ? ` – ${props.patientName.trim()}` : ""}`}
      />

      <ModalBox open={viewInvoice} onClose={() => { setSelectedAppointment(); setViewInvoice(false) }} title="View Invoice" size="fullscreen">
        {viewInvoice && <InvoicePreview invoiceId={selectedAppointment?.invoiceId} />}
      </ModalBox>
      <ModalBox open={confirmCreateInvoice} title="Create Invoice" requireConfirm onClose={() => { setConfirmCreateInvoice(false) }} onCloseSuccess={() => {setConfirmCreateInvoice(false); checkOut() }} confirmButton="Create Invoice" cancelButton="Cancel">
        <span>Do you wish to create an invoice for the appointment at this time?</span>
      </ModalBox>
      <ModalBox open={checkOutInvoice != null} onClose={() => { setCheckOutInvoice(null) }} size="fullscreen" title="Add Invoice">
        <AddInvoice appointmentId={selectedAppointment?.id} initialData={checkOutInvoice} onClose={() => { setCheckOutInvoice(null)}} refresh={() => props.refresh()} isModal />
      </ModalBox>
    </div>
  );
};

export default AppointmentTable;
